import { reversalPlank, rolloverPlank } from './LayoutFuncs'
import { rotate180Part, rotatePart } from './LayoutTool'

interface TransformEntry {
  type: 'flipX' | 'flipY' | 'rotate' | 'xyReverse'
  angle?: number
  source?: string
}

interface TransformablePart {
  _flipXCount?: number
  _flipYCount?: number
  _rotateAngle?: number
  _transformLog?: TransformEntry[]
  [key: string]: any
}

const replayingParts = new WeakSet<object>()

export function recordTransform(
  part: TransformablePart | null | undefined,
  type: TransformEntry['type'],
  angle?: number,
  source?: string
): void {
  if (!part || replayingParts.has(part)) return
  part._flipXCount = part._flipXCount ?? 0
  part._flipYCount = part._flipYCount ?? 0
  part._rotateAngle = part._rotateAngle ?? 0
  part._transformLog = part._transformLog ?? []

  if (type === 'flipX') {
    part._flipXCount += 1
  } else if (type === 'flipY') {
    part._flipYCount += 1
  } else if (type === 'rotate') {
    part._rotateAngle = (((part._rotateAngle + (angle ?? 0)) % 360) + 360) % 360
  }

  part._transformLog.push({
    type,
    angle: type === 'rotate' ? angle : undefined,
    source,
  })
}

export function recordXyReverseTransform(
  part: TransformablePart,
  source?: string
): void {
  recordTransform(part, 'flipY', 0, source || 'xyReverse')
  recordTransform(part, 'rotate', 90, source || 'xyReverse')
}

export function replayTransform(
  part: TransformablePart,
  log?: TransformEntry[] | null
): void {
  if (!part || !log?.length) return
  replayingParts.add(part)
  try {
    for (const item of log) {
      switch (item.type) {
        case 'flipX':
          reversalPlank(part)
          break
        case 'flipY':
          rolloverPlank(part)
          break
        case 'rotate':
          if (item.angle === 180) {
            rotate180Part(part)
          } else if (item.angle === 270) {
            rotatePart(rotate180Part(part))
          } else if (item.angle === 90) {
            rotatePart(part)
          }
          break
        case 'xyReverse':
          rolloverPlank(part)
          rotatePart(part)
          break
      }
    }
  } finally {
    replayingParts.delete(part)
  }
  part._flipXCount = 0
  part._flipYCount = 0
  part._rotateAngle = 0
  part._transformLog = JSON.parse(JSON.stringify(log)) as TransformEntry[]
}
